{
  "title": "Identifique a empresa para a qual trabalha",
  "explanation": "Esta informação identifica a empresa nos seus relatórios de trabalho. Não compra uma licença, não atribui propriedade nem altera permissões de veículos/GPS.",
  "collective": "Empresa coletiva (NIPC)",
  "individual": "Atividade individual (NIF)",
  "fiscalName": "Nome fiscal da atividade",
  "companyName": "Nome da empresa",
  "collectiveNameRequired": "Não foi possível validar a empresa automaticamente. Informe o nome da empresa para continuar; ele será verificado depois.",
  "invalidIdentifier": "Indique um identificador fiscal válido com nove dígitos.",
  "confirmChange": "Confirmo a mudança de empresa; o trabalho já registado mantém a empresa original.",
  "confirmRequired": "Confirme a mudança de empresa e indique o nome fiscal quando necessário.",
  "save": "Confirmar empresa de trabalho",
  "retryAction": "Tentar novamente",
  "retry": "Não foi possível validar a empresa. Tente novamente ou contate o suporte.",
  "company": "Empresa",
  "driverNif": "NIF",
  "companyNipc": "NIPC",
  "companyTaxId": "Identificador fiscal da empresa",
  "profileLoading": "Carregando o perfil",
  "sidebarLoadError": "Não foi possível carregar o perfil ou o contexto de trabalho. Tente novamente ou contate o suporte.",
  "historicalCompanyMissing": "Empresa não registrada nesta sessão em andamento",
  "license": "Licença",
  "companyLicense": "Empresarial",
  "personalMonth": "Própria - Mensal",
  "personalYear": "Própria - Anual",
  "personal": "Própria",
  "unknownLicense": "A confirmar",
  "situation": "Situação",
  "return": "Voltar ao trabalho",
  "loading": "Carregando o contexto de trabalho",
  "identify": "Identificar empresa de trabalho",
  "change": "Alterar empresa de trabalho",
  "corporateChange": "Para manter a licença empresarial, peça à empresa de destino um convite com pagamento empresarial. Esta declaração não altera seu pagador.",
  "selfPayDeclaration": "Esta declaração seleciona pagamento próprio. Não compra cobertura; o pagamento empresarial exige convite ou aprovação da empresa.",
  "invitationChange": "Empresa atual: {{current}}. Aceitar muda a empresa de trabalho para {{destination}}.",
  "invitationPaidPeriod": "Se você já tem um período próprio pago, ele continua até o fim. A cobertura empresarial fica agendada para essa data, sujeita à confirmação do encerramento da renovação e à cobertura da empresa.",
  "pending": {
    "work_company_required": "Identifique a empresa antes de iniciar novo trabalho.",
    "work_identity_unresolved": "A identidade da empresa precisa de validação. Tente novamente ou contate o suporte.",
    "work_relationship_unresolved": "O vínculo de trabalho precisa de análise verificada pelo suporte.",
    "work_funding_unresolved": "O financiamento selecionado precisa de confirmação.",
    "awaiting_coverage": "É necessária cobertura válida para a próxima sessão.",
    "awaiting_renewal_confirmation": "O financiamento empresarial agendado aguarda confirmação da cessação da renovação pessoal.",
    "future_company_coverage_unavailable": "A cobertura empresarial futura está pendente. Sua licença própria continua válida até o fim do período pago. Contate a empresa ou o suporte."
  }
}
